/// <reference path="../objects/interfaces/idictionary.ts" />
/// <reference path="../factories/blocks.localstorage.factory.ts" />
/// <reference path="../factories/blocks.sessionstorage.factory.ts" />
/// <reference path="pipelinedata.service.ts" />


module App.Services {
    export class SessionService implements App.Interfaces.ISessionService {
        static serviceId = 'sessionService';

        static $inject = [
            '$rootScope',
            Blocks.LocalStorage.factoryId,
            Blocks.SessionStorage.factoryId,
            Services.PipelineDataService.serviceId,
            Blocks.RouterFactory.factoryId
        ];

        constructor(private $rootScope: Interfaces.IAppRootScope,
                    private localStorage: App.Interfaces.IStorageBase,
                    private sessionStorage: App.Interfaces.IStorageBase,
                    private pipelineDataService: Services.IPipelineDataService,
                    private routerFactory: Blocks.Interfaces.IRouterFactory) {
            
            this.setConfiguratorType(App.Variables.configuratorType);
            this.resetMaxStepNumber();
        }

        //for debugging = faster
        get composition(): Classes.IComposition {
            return this.sessionStorage.get<Classes.IComposition>('composition');
        }
        set composition(val: Classes.IComposition) {
            this.sessionStorage.set<Classes.IComposition>('composition', val);
        }

        //todo live use this !!
        //composition: Classes.IComposition;

        configuratorType: string;
        pipelineSteps: string[];
        currentStep: string;
        maxStepNumber: number;

        get setNumber(): string {
            return this.sessionStorage.get<string>('setNumber');
        }
        set setNumber(val: string) {
            this.sessionStorage.set<string>('setNumber', val);
        }

        reset = () => {
            var tempcomposition = this.composition;
            tempcomposition = new Classes.Composition();
            this.composition = tempcomposition;
        }

        resetStoreSession = () => {
            var tempcomposition = this.composition;

            tempcomposition.selectedProducts = [];
            tempcomposition.selectedDate = null;
            tempcomposition.selectedTime = null;
            tempcomposition.selectedReplacementVehicle = null;
            tempcomposition.storeId = null;

            this.composition = tempcomposition;
        }

        setConfiguratorType = (configuratorType: string) => {
            this.configuratorType = configuratorType;

            this.pipelineDataService.getPipelineSteps().then((pipelineSteps) => {
                this.pipelineSteps = pipelineSteps;
                this.routerFactory.setPipelineRoutes(pipelineSteps);

            }).catch((err) => {
                console.log('Error loading pipeline steps');
            });
        };

        resetMaxStepNumber = () => {
            this.maxStepNumber = Constants.defaultStepNumber;
        }

    }

    app.service(SessionService.serviceId, SessionService);
}